import { CfsHtmlTemplateStyleType, TemplateContentType, TemplateImageSourceType, TemplateLogoSourceType } from "./template";

export interface MediaContentDto {
  id: number;
  name: string;
  title: string;
  configuration: MediaContentConfigurationDto;
  digitalAssets: DigitalAssetGetDto[];
  templateContentType: TemplateContentType;
}

export interface DigitalAssetGetDto {
  id?: number;
  mediaContentId?: number;
  name?: string;
  content?: string;
  title?: string;
  contentUrl?: string;
  digitalAssetType?: DigitalAssetType;
  contentType?: string;
  configuration?: DigitalAssetConfigurationDto;
}

export interface MediaContentConfigurationDto {
  defaultParameters?: KeyValueDto[];
  parameters?: HtmlTemplateParameters;
}

export interface DigitalAssetConfigurationDto {
  defaultParameters: KeyValueDto[];
  screenSize: DigitalAssetScreenSize;
}

export interface HtmlTemplateParameters {
  styleType?: CfsHtmlTemplateStyleType;
  backgroundColor?: string;
  backgroundImage?: string;
  logoUrl?: string;
  logoUrlType?: TemplateLogoSourceType;
  logoBrandId?: number;
  imageUrl?: string;
  imageUrlType?: TemplateImageSourceType;
  imageColor?: string;
  imageAnimationType?: CfsTemplateImageAnimation;
  qrCodeUrl?: string;
  buttonText?: string;
  buttonTextColor?: string;
  buttonBackgroundColor?: string;
  actionText?: string;
  actionColor?: string;
  subtitleText?: string;
  subtitleColor?: string;
  titleText?: string;
  titleColor?: string;
}

export enum CfsTemplateImageAnimation {
  RectangleVerticalMotion = "RectangleVerticalMotion",
  HorizontalFlip = "HorizontalFlip"
}

export enum CfsTemplateActionTextAnimation {
  FontSizeScale = "FontSizeScale"
}

export interface KeyValueDto {
  key: string;
  value: string;
}

export enum DigitalAssetType {
  Lottie = "Lottie",
  Html = "Html"
}

export enum DigitalAssetScreenSize {
  Compact = "Compact",
  Full = "Full",
  Vertical = "Vertical",
  Tablet = "Tablet"
}

export enum CfsDeviceType {
  Desktop = "Desktop",
  DisplayVertical = "DisplayVertical",
  TabletVertical = "TabletVertical",
  TabletHorizontal = "TabletHorizontal",
  Mobile = "Mobile"
}

export interface KeyValueAsset {
  [key: string]: string;
}
